import { TermsVersion1 as TermsVersion1_JA } from "./versions/Terms.v1";
import { TermsVersion1 as TermsVersion1_EN } from "./versions/en/Terms.v1";

export * from "./TermsContainer";

// IMPORTANT
// Export the latest version of Terms as CurrentTerms
export const CurrentTerms_JA = TermsVersion1_JA;
export const CurrentTerms_EN = TermsVersion1_EN;

export { TermsVersion1_JA, TermsVersion1_EN };
